import React, { useEffect, useState } from "react";
import "./maintenance.css";

const EMAIL = "Watours@outlook.com";

const Maintenance = () => {
  const [emailNote, setEmailNote] = useState("");

  // mailto: does nothing on devices without a mail app, so also copy the
  // address and show it. The default link behaviour is left intact.
  const handleEmailClick = () => {
    setEmailNote(`Write to us at ${EMAIL}`);
    navigator.clipboard
      ?.writeText(EMAIL)
      .then(() => setEmailNote(`${EMAIL} copied to your clipboard`))
      .catch(() => {});
  };
    
  useEffect(() => {
    // The preloader in public/index.html is normally dismissed by main.js, which
    // is injected by the footer. This page has no footer, so hide it here.
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";

    const previousTitle = document.title;
    document.title = "West African Tours | Back soon";

    // Keep the holding page out of search results while the site is on hold.
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);

    return () => {
      document.title = previousTitle;
      robots.remove();
    };
  }, []);

  return (
    <div className="mt-page">
      <header className="mt-header">
        <span className="mt-brand">West African Tours</span>
        <img
          className="mt-logo"
          src={`${process.env.PUBLIC_URL}/assets/img/WEST_AFRICAN_T.png`}
          alt=""
          width="233"
          height="236"
        />
      </header>

      <main className="mt-main">
        <span className="mt-status">
          <span className="mt-dot" aria-hidden="true" />
          <span>Scheduled maintenance</span>
        </span>

        <h1 className="mt-title">
          Something <em>wonderful</em>
          <br />
          is on its way
        </h1>

        <p className="mt-lead">
          We're giving West African Tours a fresh coat of paint. Your next
          adventure will be waiting for you very soon.
        </p>

        <svg
          className="mt-route"
          viewBox="0 0 600 150"
          role="img"
          aria-label="A plane flying between two destinations"
        >
          <defs>
            <linearGradient id="mt-trail" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#01b9b7" />
              <stop offset="1" stopColor="#f3941e" />
            </linearGradient>
          </defs>
          <path className="mt-path" d="M40 130 Q300 -30 560 130" />
          <circle className="mt-stop" cx="40" cy="130" r="8" stroke="#01b9b7" />
          <circle className="mt-stop" cx="560" cy="130" r="8" stroke="#f3941e" />
          <g transform="translate(300 50)">
            <g className="mt-plane">
              <path d="M24 0 L2 -5 L-10 -22 L-16 -22 L-10 -4 L-19 -3 L-24 -10 L-28 -10 L-24 0 L-28 10 L-24 10 L-19 3 L-10 4 L-16 22 L-10 22 L2 5 Z" />
            </g>
          </g>
        </svg>

        <div className="mt-actions">
          <a
            className="mt-btn mt-btn-primary"
            href={`mailto:${EMAIL}`}
            onClick={handleEmailClick}
          >
            Email us
          </a>
          <a className="mt-btn mt-btn-ghost" href="tel:+2204495532">
            Call +220 449 5532
          </a>
        </div>

        <output className="mt-note">{emailNote}</output>
      </main>

      <footer className="mt-footer">
        &copy; {new Date().getFullYear()} West African Tours. All rights
        reserved.
      </footer>
    </div>
  );
};

export default Maintenance;
